<div class="content-wrapper">
  <section class="content">
    <div class="box">
      <div class="box-body">
        <form [formGroup]="RecoveryCreationForm" (ngSubmit)="SaveEmployeeRecovery()">
          <!-- <mat-card class="btnCard">
            <button type="submit" *ngIf="( _global.IsAdmin || _global.IsLocationSPOC ) && !(WaiveOffStatusID == true || StatusCheck == true)"
              mat-stroked-button>{{btnValue}}</button>
            <button type="button" *ngIf=" ( _global.IsAdmin || _global.IsLocationSPOC ) && _global.IsAuditVisible && IsWaiveoffAmountCheckStatus==false" mat-stroked-button
                    (click)="openWaveOFFDialog()">Waive Off</button>
            <button type="button" *ngIf="_global.IsAuditVisible" mat-stroked-button
              (click)="openAuditTrailDialog()">Audit Trail</button>
            <button type="button" mat-stroked-button (click)="_commonService.Exit()">Exit</button>
          </mat-card> -->

          <mat-card class="btnCard" style="padding: 20px; display: flex; gap: 10px;">
            <button type="submit" 
                    *ngIf="(_global.IsAdmin || _global.IsLocationSPOC) && !(WaiveOffStatusID == true || StatusCheck == true)" 
                    mat-stroked-button>{{btnValue}}</button>
            
            <button type="button" 
                    *ngIf="(_global.IsAdmin || _global.IsLocationSPOC) && _global.IsAuditVisible && IsWaiveoffAmountCheckStatus == false" 
                    mat-stroked-button 
                    (click)="openWaveOFFDialog()">Waive Off</button>
            
            <button type="button" 
                    *ngIf="_global.IsAuditVisible" 
                    mat-stroked-button 
                    (click)="openAuditTrailDialog()">Audit Trail</button>
            
            <button type="button" 
                    mat-stroked-button 
                    (click)="_commonService.Exit()">Exit</button>
          </mat-card>
          
          <fieldset>
            <div class="panel panel-default">
              <header class="panel-heading">
                <h5 class="panel-title">{{NewRequest}}</h5>
              </header>
              <header class="panel-heading" style="text-align: right;color: red">
                <h5 class="panel-title">Status: {{StatusRecord}} | Request ID: {{NewRequestID}}</h5>
              </header>
              <header class="panel-heading">
                <h6 class="panel-title" style="color: red; font-size: 13px;text-align:left;font-style:italic ">Note :-
                  &nbsp;&nbsp; "EY does not intentionally collect any sensitive personal data from you via the Tool. The
                  Tool’s intention is not to process such information"</h6>
              </header>
              <div class="panel-body">
                <div class="row">
                  <div class="form-group col-md-6">
                    <label>Employee Name/GPN/GUI/Email</label>
                    <input class="form-control" formControlName="lblEmployeeName" *ngIf="StatusRecord!=='New'" appPreventSpecialChars readonly>
                    <p-autoComplete formControlName="UserNameEmployeeRecovery" [suggestions]="employeeList"
                      (completeMethod)="SearchActiveEmployee($event)" [readonly]="_global.IsAuditVisible"
                      placeholder="Search with Employee Name/GPN/GUI/Email" field="EmployeeName" [forceSelection]="true" [minLength]="3"
                      *ngIf="StatusRecord=='New'" (onSelect)="SetSecondaryEmployeeDetails($event)"
                      (onClear)="clearAutoComplete('UserNameEmployeeRecovery')"
                      class="full-width-autocomplete" appPreventSpecialChars>
                    </p-autoComplete> 
                  
                           
                  </div>
                  <div class="form-group col-md-6">
                    <label class="required">Email</label>
                    <input class="form-control" placeholder="Employee email" formControlName="EmailAddress" readonly>
                    <mat-error
                      *ngIf="GetFormControls('EmailAddress').invalid && (GetFormControls('EmailAddress').dirty || GetFormControls('EmailAddress').touched)"
                      class="ValidationError">
                      <mat-error *ngIf="GetFormControls('EmailAddress').errors.required">
                        Email is required.
                      </mat-error>
                    </mat-error>
                  </div>
                </div>
                <div class="row">
                  <div class="form-group col-md-6">
                    <label class="required">Employee Location</label>
                    <input class="form-control" placeholder="Employee office location"
                      formControlName="UserOfficeLocation" readonly appPreventSpecialChars>
                    <mat-error
                      *ngIf="GetFormControls('UserOfficeLocation').invalid && (GetFormControls('UserOfficeLocation').dirty || GetFormControls('UserOfficeLocation').touched)"
                      class="ValidationError">
                      <mat-error *ngIf="GetFormControls('UserOfficeLocation').errors.required">
                        Employee Location is required.
                      </mat-error>
                    </mat-error>
                  </div>
                  <div class="form-group col-md-6">
                    <label class="required">Entity</label>
                    <input class="form-control" placeholder="Employee entity" formControlName="UserEntity" readonly >
                    <mat-error
                      *ngIf="GetFormControls('UserEntity').invalid && (GetFormControls('UserEntity').dirty || GetFormControls('UserEntity').touched)"
                      class="ValidationError">
                      <mat-error *ngIf="GetFormControls('UserEntity').errors.required">
                        Entity is required.
                      </mat-error>
                    </mat-error>
                  </div>
                </div>
                <div class="row">
                  <!-- <div class="form-group col-md-6">
                    <label class="required">Asset Type</label>
                    <p-dropdown [options]="AssestTypeList" placeholder="--Select Asset Type--"
                      formControlName="AssetTypeID" [filter]="true"
                      [readonly]="(WaiveOffStatusID == true || StatusCheck == true)"
                      (onChange)="AssetTypeChange($event)">
                    </p-dropdown>
                    <mat-error
                      *ngIf="GetFormControls('AssetTypeID').invalid && (GetFormControls('AssetTypeID').dirty || GetFormControls('AssetTypeID').touched)"
                      class="ValidationError">
                      <mat-error *ngIf="GetFormControls('AssetTypeID').errors.required">
                        Asset Type is required.
                      </mat-error>
                    </mat-error>
                  </div> -->
                  <div class="form-group col-md-6">
                    <label class="required">Asset Type</label>
                    <p-dropdown [options]="AssestTypeList" placeholder="--Select Asset Type--"
                      formControlName="AssetTypeID" [filter]="true"
                      [readonly]="(WaiveOffStatusID == true || StatusCheck == true)"
                      (onChange)="AssetTypeChange($event)">
                    </p-dropdown>
                  
                    <mat-error *ngIf="GetFormControls('AssetTypeID').invalid && (GetFormControls('AssetTypeID').dirty || GetFormControls('AssetTypeID').touched)" class="ValidationError">
                      <mat-error *ngIf="GetFormControls('AssetTypeID').errors.required">
                        Asset Type is required.
                      </mat-error>
                    </mat-error>
                  </div>
                  
                  <div class="form-group col-md-6">
                    <label class="required">Asset Make & Model</label>
                    <input class="form-control" maxlength="200" placeholder="asset make & model"
                      formControlName="AssetMakeAndModel"
                      [readonly]="(WaiveOffStatusID == true || StatusCheck == true)" appPreventSpecialChars>
                    <mat-error
                      *ngIf="GetFormControls('AssetMakeAndModel').invalid && (GetFormControls('AssetMakeAndModel').dirty || GetFormControls('AssetMakeAndModel').touched)"
                      class="ValidationError">
                      <mat-error *ngIf="GetFormControls('AssetMakeAndModel').errors.required">
                        Asset Make & Model is required.
                      </mat-error>
                    </mat-error>
                  </div>
                </div>
                <div class="row">
                  <div class="form-group col-md-6">
                    <label class="required">Asset Sr No./MDN No.</label>
                    <input class="form-control" maxlength="200" placeholder="asset sr no./mdn no."
                      formControlName="AssetSrAndMDN" [readonly]="(WaiveOffStatusID == true || StatusCheck == true)" appPreventSpecialChars>
                    <mat-error
                      *ngIf="GetFormControls('AssetSrAndMDN').invalid && (GetFormControls('AssetSrAndMDN').dirty || GetFormControls('AssetSrAndMDN').touched)"
                      class="ValidationError">
                      <mat-error *ngIf="GetFormControls('AssetSrAndMDN').errors.required">
                        Asset Sr No./MDN No. is required.
                      </mat-error>
                    </mat-error>
                  </div>
                  <div class="form-group col-md-6">
                    <label class="required">Reported Location</label>
                    <p-dropdown [options]="ReportedLocationList" placeholder="--Select Reported Location--"
                      formControlName="ReportedLocationID" [filter]="true"
                      [disabled]="WaiveOffStatusID || StatusCheck"
                      (onChange)="ReportedLocationChange($event)">
                    </p-dropdown>
                    <mat-error
                      *ngIf="GetFormControls('ReportedLocationID').invalid && (GetFormControls('ReportedLocationID').dirty || GetFormControls('ReportedLocationID').touched)"
                      class="ValidationError">
                      <mat-error *ngIf="GetFormControls('ReportedLocationID').errors.required">
                        Reported Location is required.
                      </mat-error>
                    </mat-error>
                  </div>
                </div>
                <div class="row">
                  <div class="form-group col-md-6">
                    <label class="required">Penalty Type</label>
                    <p-dropdown [options]="PenaltyTypeList" placeholder="--Select Penalty Type--"
                      formControlName="PenaltyTypeID" 
                      [readonly]="(WaiveOffStatusID == true || StatusCheck == true)"
                      (onChange)="PenaltyTypeChange($event)">
                    </p-dropdown>
                    <mat-error
                      *ngIf="GetFormControls('PenaltyTypeID').invalid && (GetFormControls('PenaltyTypeID').dirty || GetFormControls('PenaltyTypeID').touched)"
                      class="ValidationError">
                      <mat-error *ngIf="GetFormControls('PenaltyTypeID').errors.required">
                        Penalty Type is required.
                      </mat-error>
                    </mat-error>
                  </div>
                  <!-- <div class="form-group col-md-6">
                    <label class="required">Reported Date</label>
                    <div class="input-group">
                      <input [matDatepicker]="picker" formControlName="ReportedDate" class="form-control" placeholder="Reported date" readonly>
                      <div class="input-group-append">
                        <mat-datepicker-toggle class="input-group-text" matSuffix [for]="picker"></mat-datepicker-toggle>
                      </div>
                      <mat-datepicker #picker></mat-datepicker>
                    </div>
                    <mat-error *ngIf="GetFormControls('ReportedDate').invalid && (GetFormControls('ReportedDate').dirty || GetFormControls('ReportedDate').touched)" class="ValidationError">
                      <mat-error *ngIf="GetFormControls('ReportedDate').errors.required">
                        Reported Date is required.
                      </mat-error>
                    </mat-error>
                  </div> -->
                  <div class="form-group col-md-6">
                    <label class="required">Reported Date</label>
                    <div class="input-group">
                      <input [matDatepicker]="picker" 
                             formControlName="ReportedDate" 
                             class="form-control" 
                             placeholder="Reported date" 
                             readonly>
                             
                      <!-- Ensure correct wrapping for alignment -->
                      <div class="input-group-append">
                        <mat-datepicker-toggle matSuffix [for]="picker" class="datepicker-icon"></mat-datepicker-toggle>
                      </div>
                      
                      <mat-datepicker #picker></mat-datepicker>
                    </div>
                  
                    <!-- Validation Message -->
                    <mat-error *ngIf="GetFormControls('ReportedDate').invalid && (GetFormControls('ReportedDate').dirty || GetFormControls('ReportedDate').touched)" 
                               class="ValidationError">
                      <mat-error *ngIf="GetFormControls('ReportedDate').errors.required">
                        Reported Date is required.
                      </mat-error>
                    </mat-error>
                  </div>
                  
                  
                </div>
                <div class="row">
                  <div class="form-group col-md-6">
                    <label class="required">Penalty Amount.</label>
                    <input class="form-control" maxlength="10" placeholder="penalty amount"
                      formControlName="PenaltyAmount" onpaste="return false" (ngModelChange)="ValidationMessage();"
                      appTwoDigitDecimaNumber [readonly]="(WaiveOffStatusID == true || StatusCheck == true)">
                    <mat-error
                      *ngIf="GetFormControls('PenaltyAmount').invalid && (GetFormControls('PenaltyAmount').dirty || GetFormControls('PenaltyAmount').touched)"
                      class="ValidationError">
                      <mat-error *ngIf="GetFormControls('PenaltyAmount').errors.required">
                        Penalty Amount is required.
                      </mat-error>
                    </mat-error>
                  </div>
                  <div class="form-group col-md-6" *ngIf="_global.IsAuditVisible">
                    <label>Net Recovery Amount</label>
                    <input class="form-control" maxlength="10" placeholder="net recovery amount"
                      formControlName="NetRecoveryAmountID" readonly>
                  </div>
                </div>
                <br>
                <div *ngIf="WaiveOffStatusID==true">
                  <mat-card class="mat-border">
                    <div class="panel panel-default">
                      <header class="panel-heading">
                        <h5 class="panel-title">Waive Off</h5>
                      </header>
                    </div>
                    <div class="tabel-loading-shade" *ngIf="isLoadingResults">
                      <mat-spinner *ngIf="isLoadingResults"></mat-spinner>
                    </div>
                    <div class="table-container">
                      <table mat-table [dataSource]="EmployeeWaiveOffDataSource" style="width:100% !important">
                        <!-- Position Column -->
                        <ng-container matColumnDef="RequestRecoveryNumber">
                          <th mat-header-cell *matHeaderCellDef> Request Number </th>
                          <td mat-cell *matCellDef="let element" (click)="$event.stopPropagation()"><a> <span
                                style="display:none">{{element.RecoveryID}}</span> {{element.RequestRecoveryNumber}}</a>
                          </td>
                        </ng-container>
                        <!-- Name Column -->
                        <ng-container matColumnDef="IsFullWaiveOff">
                          <th mat-header-cell *matHeaderCellDef> Waive Off Type </th>
                          <td mat-cell *matCellDef="let element" (click)="$event.stopPropagation()">
                            {{element.IsFullWaiveOff }} </td>
                        </ng-container>

                        <ng-container matColumnDef="WaiveOffAmount">
                          <th mat-header-cell *matHeaderCellDef> Waive Off Amount </th>
                          <td mat-cell *matCellDef="let element" (click)="$event.stopPropagation()">
                            {{element.WaiveOffAmount}} </td>
                        </ng-container>

                        <ng-container matColumnDef="WaiverDate">
                          <th mat-header-cell *matHeaderCellDef> Waiver Date </th>
                          <td mat-cell *matCellDef="let element" (click)="$event.stopPropagation()">
                            {{element.WaiverDate | date: 'dd/MM/yyyy'}} </td>
                        </ng-container>

                        <ng-container matColumnDef="Remarks">
                          <th mat-header-cell *matHeaderCellDef> Remarks </th>
                          <td mat-cell *matCellDef="let element" (click)="$event.stopPropagation()"> {{element.Remarks}}
                          </td>
                        </ng-container>
                        <!-- <ng-container matColumnDef="JVNumber">
                          <th mat-header-cell *matHeaderCellDef> JV Number </th>
                          <td mat-cell *matCellDef="let element" (click)="$event.stopPropagation()">
                            {{element.JVNumber}} </td>
                        </ng-container> -->
                        <ng-container matColumnDef="JVNumber">
                          <th mat-header-cell *matHeaderCellDef> JV Number </th>
                          <td mat-cell *matCellDef="let element" 
                          >
                          <!-- (click)="$event.stopPropagation()" -->

                            {{element.JVNumber}}
                          </td>
                        </ng-container>
                        <ng-container matColumnDef="AttachmentName">
                          <th mat-header-cell *matHeaderCellDef> Attachment </th>
                          <td mat-cell *matCellDef="let element" style="color: dodgerblue"><a> <span
                                (click)="ShowAttachment(element.AttachmentID);"
                                style="display:none">{{element.AttachmentID}}</span> {{element.AttachmentName}}</a>
                          </td>
                        </ng-container>
                        <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
                        <tr mat-row *matRowDef="let row; columns: displayedColumns;" style="cursor:pointer;"
                          (click)="ShowAttachment(row)"></tr>
                      </table>
                    </div>
                  </mat-card>
                </div>
              </div>
            </div>
          </fieldset>
        </form>
      </div>
    </div>
  </section>
</div>